import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import GalleryHome from './pages/Gallery'
import GalleryTeto from './pages/GalleryTeto'
import GalleryTerasz from './pages/GalleryTerasz'
import GalleryAutobeallo from './pages/GalleryAutobeallo'
import GalleryKsz from './pages/GalleryKsz'
import Konnyuszerkezetes from './pages/Konnyuszerkezetes'

function App() {
  return (
    <Router>   
      <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/konnyuszerkezetes" element={<Konnyuszerkezetes />} />
          <Route path='/gallery' element={<GalleryHome />}/>
          <Route path='/gallery/teto' element={<GalleryTeto />}/>
          <Route path='/gallery/konnyuszerkezetes' element={<GalleryKsz />}/>
          <Route path='/gallery/autobeallo' element={<GalleryAutobeallo />}/>
          <Route path='/gallery/terasz' element={<GalleryTerasz />}/>
        </Routes>
      <Footer />
    </Router>
  );
}

export default App;